/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberApproveTermsData } from '../models/MemberApproveTermsData';
import type { MemberSignatureData } from '../models/MemberSignatureData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WebSocketService {

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1Signature(
        requestBody?: MemberSignatureData,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/signature',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiV1Terms(
        requestBody?: MemberApproveTermsData,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/terms',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
